export default __webpack_public_path__ + "static/media/check.38a88111.svg";